import { RowProps } from "../../../components";
import { searchUsersSiteCoreKeys } from "../siteCore/SiteCoreKeys";

export const UsersSearchFormKey = {
  userName: "userName",
  userNameFilter: "userNameFilter",
  userEmail: "userEmail",
  userEmailFilter: "userEmailFilter",
  serviceOffice: "serviceOffice",
  serviceOfficeFilter: "serviceOfficeFilter",
  userStatus: "userStatus",
  role: "role",
} as const;

export interface UsersSearchFormType {
  userName: string;
  userNameFilter: string;
  userEmail: string;
  userEmailFilter: string;
  serviceOffice: string;
  serviceOfficeFilter: string;
  userStatus: string;
  role: string;
}

export const UsersSearchFormDefaultValues = {
  [UsersSearchFormKey.userName]: "",
  [UsersSearchFormKey.userNameFilter]: searchUsersSiteCoreKeys.contains,
  [UsersSearchFormKey.userEmail]: "",
  [UsersSearchFormKey.userEmailFilter]: searchUsersSiteCoreKeys.contains,
  [UsersSearchFormKey.serviceOffice]: "",
  [UsersSearchFormKey.serviceOfficeFilter]: searchUsersSiteCoreKeys.contains,
  [UsersSearchFormKey.userStatus]: "",
  [UsersSearchFormKey.role]: "",
};

export const UsersSearchResultKey = {
  userName: "userName",
  userEmail: "userEmail",
  role: "role",
  country: "country",
  serviceOfficeName: "serviceOfficeName",
  userMobileNumber: "userMobileNumber",
  userStatus: "userStatus",
  createdDate: "createdDate",
} as const;

export interface RoleDetails {
  roleId?: string;
  role?: string;
}

export interface UserCountry {
  countryCode: string;
  countryName: string;
}

export interface SearchUserDataResponse extends RowProps {
  id: string;
  userName?: string;
  userEmail: string;
  role: string[];
  roleNames: string[];
  country: UserCountry[];
  serviceOfficeName: string[];
  userStatus: string | boolean;
  createdTimeStamp: string;
}

export const USER_STATUS_TYPE_VALUE = {
  ACTIVE: "true",
  INACTIVE: "false",
};
